import React from 'react';
import styled from 'styled-components';

const StarRatingContainer = styled.span`
    display: inline-block;
    font-size: ${props => props.small ? '10px' : '13px'};
    line-height: 1;
    letter-spacing: ${props => props.small ? '-1px' : '-1.5px'};
`;

const Star = styled.span`
    color: ${props => props.filled ? '#ffa500' : '#e8e8e8'};
    font-size: inherit;
`;

/**
 * Component hiển thị rating với sao vàng và sao xám
 * @param {number} rating - Số sao đã đánh giá (1-5)
 * @param {number} maxStars - Tổng số sao tối đa (default: 5)
 * @param {boolean} small - Hiển thị size nhỏ cho inline text
 */
const StarRating = ({ rating = 0, maxStars = 5, small = false }) => {
    const stars = [];
    for (let i = 1; i <= maxStars; i++) {
        stars.push(
            <Star key={i} filled={i <= rating}>★</Star>
        );
    }
    return <StarRatingContainer small={small}>{stars}</StarRatingContainer>;
};

export default StarRating;
